import { render, staticRenderFns } from "./LabeledInfo.vue?vue&type=template&id=2f971984&scoped=true&"
import script from "./LabeledInfo.vue?vue&type=script&lang=js&"
export * from "./LabeledInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f971984",
  null
  
)

export default component.exports